
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { StudentFormValues } from "../schema/studentSchema";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useIsMobile } from "@/hooks/use-mobile";
import { useTranslations } from "@/hooks/useTranslations";

interface FinancialTabProps {
  form: UseFormReturn<StudentFormValues>;
}

export const FinancialTab = ({ form }: FinancialTabProps) => {
  const isMobile = useIsMobile();
  const { t } = useTranslations("students");
  
  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="monthly_fee"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t("form.monthlyFee")}</FormLabel>
            <FormControl>
              <Input placeholder={t("form.monthlyFee")} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-6`}>
        <FormField
          control={form.control}
          name="payment_status"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("form.paymentStatus")}</FormLabel>
              <Select 
                onValueChange={field.onChange} 
                defaultValue={field.value}
                value={field.value}
              >
                <FormControl>
                  <SelectTrigger className="text-muted-foreground">
                    <SelectValue placeholder={t("form.selectPaymentStatus")} />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="pago">{t("form.paymentStatuses.paid")}</SelectItem>
                  <SelectItem value="pendente">{t("form.paymentStatuses.pending")}</SelectItem>
                  <SelectItem value="atrasado">{t("form.paymentStatuses.overdue")}</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="payment_method"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("form.paymentMethod")}</FormLabel>
              <Select 
                onValueChange={field.onChange} 
                defaultValue={field.value}
                value={field.value}
              >
                <FormControl>
                  <SelectTrigger className="text-muted-foreground">
                    <SelectValue placeholder={t("form.selectPaymentMethod")} />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="transferencia">{t("form.paymentMethods.transfer")}</SelectItem>
                  <SelectItem value="dinheiro">{t("form.paymentMethods.cash")}</SelectItem>
                  <SelectItem value="cartao">{t("form.paymentMethods.card")}</SelectItem>
                  <SelectItem value="debito_direto">{t("form.paymentMethods.directDebit")}</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      <FormField
        control={form.control}
        name="payment_notes"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t("form.paymentNotes")}</FormLabel>
            <FormControl>
              <Textarea 
                placeholder={t("form.paymentNotes")} 
                {...field} 
                className="resize-none min-h-[100px]"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
